import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { components } from "@/assets/ts";

const routes: Array<RouteRecordRaw> = [
  // role Superadmin
  {
    path: "/",
    redirect: "/sign-in",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/superadmin/dashboard/dashboard.vue"),
      },
      {
        path: "/profile",
        name: "profile",
        component: () => import("@/views/profile.vue"),
      },
      // {
      //   path: "/notification",
      //   name: "notification",
      //   component: () => import("@/views/superadmin/notification/notification.vue"),
      // },

      // router institusi
      {
        path: "/datainstitusi",
        name: "datainstitusi",
        component: () =>
          import("@/views/superadmin/datainstitusi/datainstitusi.vue"),
      },
      {
        path: "/datainstitusi/:id",
        name: "datainstitusi/update-datainstitusi",
        component: () =>
          import("@/views/superadmin/datainstitusi/detail-datainstitusi.vue"),
      },

      // router pendaftar
      {
        path: "/datapendaftar",
        name: "datapendaftar",
        component: () =>
          import("@/views/superadmin/datapendaftar/datapendaftar.vue"),
      },
      {
        path: "/datapendaftar/institusidetail/:id",
        name: "datapendaftar/detail-datapendaftar-institusi",
        component: () =>
          import(
            "@/views/superadmin/datapendaftar/detail-datapendaftar-institusi.vue"
          ),
      },
      {
        path: "/datapendaftar/detail/:id",
        name: "datapendaftar/detail-datapendaftar",
        component: () =>
          import("@/views/superadmin/datapendaftar/detail-datapendaftar.vue"),
      },

      // router calon siswa
      {
        path: "/calonsiswa",
        name: "calonsiswa",
        component: () => import("@/views/superadmin/calonsiswa/calonsiswa.vue"),
      },
      {
        path: "/calonsiswa/update/:companyId/:id",
        name: "calonsiswa/update-calonsiswa",
        component: () =>
          import("@/views/superadmin/calonsiswa/edit-calonsiswa.vue"),
      },
      {
        path: "/calonsiswa/institusidetail/:id",
        name: "calonsiswa/detail-calonsiswa-institusi",
        component: () =>
          import(
            "@/views/superadmin/calonsiswa/detail-calonsiswa-institusi.vue"
          ),
      },
      {
        path: "/calonsiswa/detail/:companyId/:id",
        name: "calonsiswa/detail-calonsiswa",
        component: () =>
          import("@/views/superadmin/calonsiswa/detail-calonsiswa.vue"),
      },
      {
        path: "/calonsiswa/preview/:companyId/:id",
        name: "preview",
        component: () =>
          import("@/views/superadmin/calonsiswa/preview-calonsiswa.vue"),
      },
      {
        path: "/log-migration/:companyId/:id",
        name: "log-migration-detail",
        component: () =>
          import(
            "@/views/superadmin/logMigrasi/log-migrasi-detail.vue"
          ),
      },
      {
        path: "/log-migration/:companyId",
        name: "log-migration",
        component: () =>
          import(
            "@/views/superadmin/logMigrasi/log-migrasi.vue"
          ),
      },

      // router invoices
      {
        path: "/invoices",
        name: "invoices",
        component: () => import("@/views/superadmin/invoices/invoices.vue"),
      },
      {
        path: "/invoices/institusidetail/:id",
        name: "invoices/detail-invoices-institusi",
        component: () =>
          import("@/views/superadmin/invoices/detail-invoices-institusi.vue"),
      },
      {
        path: "/invoices/update/:id",
        name: "invoices/update-invoices",
        component: () =>
          import("@/views/superadmin/invoices/edit-invoices.vue"),
      },
      {
        path: "/invoices/detail/:id",
        name: "invoices/detail-invoices",
        component: () =>
          import("@/views/superadmin/invoices/detail-invoices.vue"),
      },

      // router setting ppdb
      {
        path: "/settingppdb",
        name: "settingppdb",
        component: () =>
          import("@/views/superadmin/settingppdb/settingppdb.vue"),
      },

      // router setting invoices
      {
        path: "/settinginvoices",
        name: "settinginvoices",
        component: () =>
          import("@/views/superadmin/settinginvoices/settinginvoices.vue"),
      },
      {
        path: "/settinginvoices/:id",
        name: "settinginvoices/update-settinginvoices",
        component: () =>
          import("@/views/superadmin/settinginvoices/edit-settinginvoices.vue"),
      },
      {
        path: "/settinginvoices/detail/:id",
        name: "settinginvoices/detail-settinginvoices",
        component: () =>
          import(
            "@/views/superadmin/settinginvoices/detail-settinginvoices.vue"
          ),
      },

      // router setting unit
      {
        path: "/settingunit",
        name: "settingunit",
        component: () =>
          import("@/views/superadmin/settingunit/settingunit.vue"),
      },

      // router setting Institusi
      {
        path: "/settinginstitusi",
        name: "settinginstitusi",
        component: () =>
          import("@/views/superadmin/settinginstitusi/settinginstitusi.vue"),
      },
      {
        path: "/settinginstitusi/:id",
        name: "settinginstitusi/update-settinginstitusi",
        component: () =>
          import(
            "@/views/superadmin/settinginstitusi/edit-settinginstitusi.vue"
          ),
      },
      {
        path: "/settinginstitusi/detail/:id",
        name: "settinginstitusi/detail-settinginstitusi",
        component: () =>
          import(
            "@/views/superadmin/settinginstitusi/detail-settinginstitusi.vue"
          ),
      },

      // router setting tampilan
      {
        path: "/settingtampilan",
        name: "settingtampilan",
        component: () =>
          import("@/views/superadmin/settingtampilan/settingtampilan.vue"),
      },
      {
        path: "/settinglandingpage",
        name: "settinglandingpage",
        component: () =>
          import(
            "@/views/superadmin/settinglandingpage/settinglandingpage.vue"
          ),
      },
      {
        path: "/settingcompany",
        name: "settingcompany",
        component: () => import("@/views/superadmin/settingcompany/settingcompany.vue"),
      },

      // router setting field
      {
        path: "/settingField",
        name: "settingField",
        component: () =>
          import("@/views/superadmin/settingField/settingField.vue"),
      },

      // router setting custom notifikasi
      {
        path: "/settingNotifikasi",
        name: "settingNotifikasi",
        component: () =>
          import(
            "@/views/superadmin/settingCustomNotifikasi/setting-custom-notifikasi.vue"
          ),
      },
      {
        path: "/settingNotifikasi/set/:type",
        name: "setNotifikasi",
        component: () => import("@/views/superadmin/settingCustomNotifikasi/set-custom-notifikasi.vue"),
      },

      // router custom kartu pendaftaran
      {
        path: "/registrationCard",
        name: "registrationCard",
        component: () =>
          import("@/views/superadmin/registrationCard/registrationCard.vue"),
      },
      {
        path: "/registrationCard/:companyId/:id",
        name: "registrationCardForm",
        component: () =>
          import(
            "@/views/superadmin/registrationCard/registrationCardForm.vue"
          ),
      },

      // router Manajemen Pengguna
      {
        path: "/manajemenpengguna",
        name: "manajemenpengguna",
        component: () =>
          import("@/views/superadmin/manajemenpengguna/manajemenpengguna.vue"),
      },
      {
        path: "/manajemenpengguna/:id",
        name: "manajemenpengguna/manajemen-pengguna-institusi",
        component: () =>
          import(
            "@/views/superadmin/manajemenpengguna/manajemen-pengguna-institusi.vue"
          ),
      },

      // router pendaftar
      {
        path: "/datapendaftar",
        name: "datapendaftar",
        component: () =>
          import("@/views/superadmin/datapendaftar/datapendaftar.vue"),
      },
      {
        path: "/datapendaftar/institusidetail/:id",
        name: "datapendaftar/detail-datapendaftar-institusi",
        component: () =>
          import(
            "@/views/superadmin/datapendaftar/detail-datapendaftar-institusi.vue"
          ),
      },
      {
        path: "/datapendaftar/detail/:id",
        name: "datapendaftar/detail-datapendaftar",
        component: () =>
          import("@/views/superadmin/datapendaftar/detail-datapendaftar.vue"),
      },

      // router news-info
      {
        path: "/dataNewsInfo",
        name: "dataNewsInfo",
        component: () =>
          import("@/views/superadmin/dataNewsInfo/dataNewsInfo.vue"),
      },
      {
        path: "/dataNewsInfo/dataNewsInfodetail/:id",
        name: "dataNewsInfo/detail-dataNewsInfo-institusi",
        // component: () =>
        // import("@/views/superadmin/dataNewsInfo/dataNewsInfo.vue"),
        component: () =>
          import(
            "@/views/superadmin/dataNewsInfo/detail-dataNewsInfo-institusi.vue"
          ),
      },
      {
        path: "/dataNewsInfo/detail/:id",
        name: "dataNewsInfo/detail-dataNewsInfo",
        component: () =>
          import("@/views/superadmin/dataNewsInfo/detail-dataNewsInfo.vue"),
      },
      {
        path: "/dataNewsInfo/edit/:id",
        name: "dataNewsInfo/edit-dataNewsInfo",
        component: () =>
          import("@/views/superadmin/dataNewsInfo/edit-dataNewsInfo.vue"),
      },
      {
        path: "/dataNewsInfo/:id",
        name: "dataNewsInfo/add-dataNewsInfo",
        component: () =>
          import("@/views/superadmin/dataNewsInfo/edit-dataNewsInfo.vue"),
      },

      // router Pemberitahuan
      {
        path: "/pemberitahuan",
        name: "pemberitahuan",
        component: () =>
          import("@/views/superadmin/pemberitahuan/pemberitahuan.vue"),
      },
      {
        path: "/pemberitahuan/detail/:id",
        name: "pemberitahuan/pemberitahuan-detail",
        component: () =>
          import("@/views/superadmin/pemberitahuan/pemberitahuan_detail.vue"),
      },
      {
        path: "/Manajemen Berita",
        name: "Manajemen Berita",
        component: () =>
          import("@/views/superadmin/manajemenberita/manajemenberita.vue"),
      },
      {
        path: "/manajemenberita/tambah",
        name: "tambahberita",
        component: () =>
          import("@/views/superadmin/manajemenberita/tambahberita.vue"),
      },
    ],
  },

  // AUTH
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "sign-in",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
      },
      {
        path: "/sign-up",
        name: "sign-up",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUp.vue"),
      },
      {
        path: "/sign-up-form/:otp/:regId/:email",
        name: "sign-up-form",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignUpForm.vue"),
      },
      {
        path: "/sign-up/input-password",
        name: "sign-up-input-password",
        component: () =>
          import(
            "@/views/crafted/authentication/basic-flow/SignUpInputPassword.vue"
          ),
      },
      {
        path: "/password-reset",
        name: "password-reset",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/PasswordReset.vue"),
      },
      {
        path: "/password-reset/:otp/:regId/:email",
        name: "password-reset-create-password",
        component: () =>
          import(
            "@/views/crafted/authentication/basic-flow/PasswordResetCreatePassword.vue"
          ),
      },
      {
        path: "/reset-password/:token/:email/:id",
        name: "reset-password",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/setuplogin.vue"),
      },
    ],
  },

  {
    path: "/sign-up/check-email",
    name: "check-email",
    component: () =>
      import("@/views/crafted/authentication/basic-flow/ThanksPage.vue"),
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(() => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
